import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { PieChart, Zap, Target, Users, AlertCircle, DownloadCloud } from 'lucide-react';

export function ReportsKpiDashboard() {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng Mẫu Báo Cáo',
      value: 45,
      suffix: 'Mẫu',
      icon: PieChart,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: 'Đã chuẩn hóa',
      chartColor: 'bg-indigo-500',
      chartData: [40, 41, 42, 43, 44, 45, 45]
    },
    {
      title: 'Tự Động Hóa',
      value: 85,
      suffix: '%',
      icon: Zap,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'up',
      trendValue: 'Tăng 5%',
      chartColor: 'bg-amber-500',
      chartData: [75, 78, 80, 81, 83, 84, 85]
    },
    {
      title: 'KPI Trọng Yếu',
      value: 12,
      suffix: 'Chỉ tiêu',
      icon: Target,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'neutral',
      trendValue: 'Đạt chuẩn',
      chartColor: 'bg-emerald-500',
      chartData: [12, 12, 12, 12, 12, 12, 12]
    },
    {
      title: 'Lượt Truy Cập',
      value: 1.2,
      suffix: 'k',
      icon: Users,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'up',
      trendValue: 'Tuần này',
      chartColor: 'bg-blue-500',
      chartData: [0.8, 0.9, 0.95, 1.0, 1.1, 1.15, 1.2]
    },
    {
      title: 'Cảnh Báo Lệch',
      value: 3,
      suffix: 'Hạng mục',
      icon: AlertCircle,
      color: 'text-red-600',
      bg: 'bg-red-50',
      trend: 'down',
      trendValue: 'Đã kiểm soát',
      chartColor: 'bg-red-500',
      chartData: [8, 7, 5, 4, 3, 3, 3]
    },
    {
      title: 'Lượt Xuất Dữ Liệu',
      value: 250,
      suffix: 'File',
      icon: DownloadCloud,
      color: 'text-purple-600',
      bg: 'bg-purple-50',
      trend: 'up',
      trendValue: 'Excel/PDF',
      chartColor: 'bg-purple-500',
      chartData: [200, 210, 220, 230, 235, 240, 250]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
